import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './store.js';
import VueCookies from 'vue-cookies'
import {EventBus} from "./event-bus";

Vue.use(VueRouter)
Vue.use(VueCookies)

import Login from './pages/Login.vue';
import Home from './pages/Home.vue';
import OrderService from './pages/OrderService.vue';
import CookiePolicy from './pages/CookiePolicy.vue';
import ChargingStations from './pages/ChargingStations.vue';
import ChargingStation from './pages/ChargingStation.vue';
import Service from './pages/Service.vue';
import Layout from './layouts/Layout.vue';
import OrderInspector from "./pages/OrderInspector.vue";

const router = new VueRouter({
    routes: [
        {
            path: '/login',
            component: Vue.component('Login', Login),
            name: 'login',
            meta: {
                guest: true
            }
        },
        {
            path: '/',
            redirect: {name: 'services'},
            name: 'layout',
            component: Vue.component('Layout', Layout),
            children: [
                {
                    path: 'services',
                    name: 'services',
                    meta: {
                        guest: false
                    },
                    component: Vue.component('Home', Home),
                    children: [
                        {
                            path: ':slug',
                            name: 'service',
                            component: Vue.component('Service', Service),
                            meta: {
                                guest: false,
                            }
                        }
                    ]
                },
                {
                    path: 'services/:slug/order',
                    name: 'orderservice',
                    component: Vue.component('OrderService', OrderService),
                    meta: {
                        guest: false,
                    }
                },
                {
                    path: 'services/:slug/order-inspector',
                    name: 'orderinspector',
                    component: Vue.component('OrderInspector', OrderInspector),
                    meta: {
                        guest: false,
                    }
                },
                {
                    path: '_=_',
                    redirect: '/'
                },
            ]
        },
        {
            path: '/cookie-policy',
            component: Vue.component('CookiePolicy', CookiePolicy),
            name: 'cookies',
            meta: {
                guest: true
            }
        },
        {
            path: '/charging-stations',
            component: Vue.component('ChargingStations', ChargingStations),
            name: 'charging-stations',
            meta: {
                guest: true
            },
            children: [
                {
                    path: ':slug',
                    name: 'charging-station',
                    component: Vue.component('Home', ChargingStation),
                    meta: {
                        guest: true
                    }
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    let localeUrlSegment = to.path.split('/');
    localeUrlSegment.shift();

    if (localeUrlSegment[0] === 'en') {
        localStorage.setItem('lang', 'en');
        $cookies.set('lang', 'en', 60 * 60 * 24 * 30);

        if (localeUrlSegment[1] === 'cookie-policy') {
            next({ name: 'cookies' });
        } else if (localeUrlSegment[1] === 'charging-stations') {
            next({ name: 'charging-stations' });
        } else {
            next({ name: 'login', params: { onLogin: to.path }, query: to.query });
        }

        return window.location.reload();
    }

    if (to.query.utm_source) {
        $cookies.set('utmSource', to.query.utm_source, 1440 * 60);
    }

    if (to.query.utm_medium) {
        $cookies.set('utmMedium', to.query.utm_medium, 1440 * 60);
    }

    if (to.meta.guest == false) {
        if (store.state.client.jwt && store.state.client.license_plate && (store.state.client.workroom || store.state.client.make_id)) {
            return next();
        }

        //store.dispatch('flashMessageShow', { type: 'error', message: 'Musíte se autorizovat.' }, { root: true })

        return next({ name: 'login', params: { onLogin: to.path } });
    }

    if (to.meta.guest === true) {
        if (store.state.client.jwt && store.state.client.license_plate && (store.state.client.workroom || store.state.client.make_id)) {
            if (store.state.client.client_personal_data && store.state.client.client_personal_data.yourpass_id) {
                localStorage.clear();
                return next();
            } else {
                if (to.query.yourPassId) {
                    localStorage.clear();
                    return next();
                }

                if (to.name == 'login') {
                    return next('/');
                } else {
                    return next();
                }
            }
        }

        return next();
    }
});

export default router;
